import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { CacheTags, PaginatedRequest, SomeRequest } from 'types';
import { UserResponse } from './bindings/UserResponse';
import { User } from './bindings/User';
import { FetchResponse } from './bindings/FetchResponse';
import { OdinBaseQuery } from './core';
import { PutUserRequest } from './bindings/PutUserRequest';
import { PostUserRequest } from './bindings/PostUserRequest';

export const usersApi = createApi({
  reducerPath: 'users',
  baseQuery: OdinBaseQuery,
  tagTypes: [CacheTags.users],
  endpoints: (builder) => ({
    fetchUsersPage: builder.query<
      FetchResponse<UserResponse>,
      PaginatedRequest
    >({
      query: (payload) => ({
        url: '/api/ca/users',
        method: 'GET',
        params: payload,
      }),
    }),
    fetchSomeUsers: builder.query<FetchResponse<UserResponse>, SomeRequest>({
      query: (payload) => ({
        url: '/api/ca/users',
        method: 'GET',
        params: payload,
      }),
    }),
    postUser: builder.mutation<UserResponse, PostUserRequest>({
      query: (payload) => ({
        url: `/api/ca/users`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: () => [
        {
          type: CacheTags.users,
          id: CacheTags.partial,
        },
      ],
    }),
    putUser: builder.mutation<UserResponse, { id: string } & PutUserRequest>({
      query: (payload) => ({
        url: `/api/ca/users/${payload.id}`,
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: (_, __, { id }) => [
        {
          type: CacheTags.users,
          id: id,
        },
        {
          type: CacheTags.users,
          id: CacheTags.partial,
        },
      ],
    }),
  }),
});

export const {
  usePostUserMutation,
  usePutUserMutation,
  useFetchUsersPageQuery,
  useFetchSomeUsersQuery,
} = usersApi;
